import { render, staticRenderFns } from "./ProjectsGallery.vue?vue&type=template&id=13ba5df8&scoped=true&"
import script from "./ProjectsGallery.vue?vue&type=script&lang=js&"
export * from "./ProjectsGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsGallery.vue?vue&type=style&index=0&id=13ba5df8&prod&scoped=true&lang=css&"
import style1 from "./ProjectsGallery.vue?vue&type=style&index=1&id=13ba5df8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ba5df8",
  null
  
)

export default component.exports